<script setup>
import { ref } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const props = defineProps({
  value: {
    type: String,
    required: true,
  },
  wrapperClass: {
    type: String,
    default: "",
  },
  buttonClass: {
    type: String,
    default: "",
  },
  copiedTextClass: {
    type: String,
    default: "ml-2 animate-fly-up text-primary",
  },
  copiedTextPosition: {
    type: String,
    default: "right",
    validator: (value) => ["right", "above", "below", "left"].includes(value),
  },
});

const showCopied = ref(false);

function handleCopy(e) {
  e.preventDefault();
  e.stopPropagation();
  navigator.clipboard.writeText(props.value);
  showCopied.value = true;
  setTimeout(() => {
    showCopied.value = false;
  }, 750);
}

const getPositionClasses = (position) => {
  const baseClasses = "absolute whitespace-nowrap";

  switch (position) {
    case "above":
      return `${baseClasses} -top-6 left-1/2 transform -translate-x-1/2`;
    case "below":
      return `${baseClasses} top-full left-1/2 transform -translate-x-1/2 mt-1`;
    case "left":
      return `${baseClasses} right-full top-1/2 transform -translate-y-1/2 mr-2`;
    case "right":
    default:
      return "ml-2 animate-fly-up";
  }
};

const defaultButtonClass =
  "inline-flex h-10 items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground ring-offset-background transition-colors hover:bg-primary/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0";
</script>

<template>
  <div :class="['relative inline-flex items-center', wrapperClass]">
    <button type="button" :class="buttonClass || defaultButtonClass" @click="handleCopy">
      <slot />
    </button>
    <span
      v-if="showCopied"
      :class="[
        copiedTextPosition === 'right' ? copiedTextClass : getPositionClasses(copiedTextPosition),
        copiedTextPosition !== 'right' ? 'animate-pulse text-primary' : '',
      ]"
    >
      {{ t("msg.copied!") }}
    </span>
  </div>
</template>
